export default () => ({
    isLoading: false,
    generatorRules: [],
    generatorRuleTypes: []
});
